// Wait for announcement box to close before removing overflow
const waitForAnnouncementClose = () => {
    const body = document.body;
    if (!body.classList.contains('body--announcement-visible')) {
        body.classList.remove("overflow--hidden");
        return;
    }
    
    // If announcement is visible, wait for it to be removed
    const observer = new MutationObserver(() => {
        if (!body.classList.contains('body--announcement-visible')) {
            body.classList.remove("overflow--hidden");
            observer.disconnect();
        }
    });
    
    observer.observe(body, { attributes: true, attributeFilter: ['class'] });
};

// Delay overflow removal if announcement is present
setTimeout(waitForAnnouncementClose, 3000);

// Force top on homepage only
(() => {
    const cls = 'body--homepage';
    const body = document.body;
    if (!body || !body.classList.contains(cls)) return;

    // Prevent browser restoring old scroll position
    if ('scrollRestoration' in history) history.scrollRestoration = 'manual';

    const toTop = () => window.scrollTo(0, 0);

    // Run immediately (covers most cases)
    toTop();

    // In case layout shifts after load
    window.addEventListener('load', toTop, { once: true });

    // Handle bfcache (back/forward navigation)
    window.addEventListener('pageshow', e => { if (e.persisted) toTop(); });
})();